export const STORAGE_KEY = 'keremlisoz:v1';
export const DEFAULT_STATE = { language: 'tk', theme: 'light', fontScale: 1, last: null };
export function readState(storage) {
  try {
    const data = JSON.parse(storage.getItem(STORAGE_KEY));
    if (!data || typeof data !== 'object') return { ...DEFAULT_STATE };
    const last = data.last;
    return {
      language: ['tk', 'ru', 'en'].includes(data.language) ? data.language : 'tk',
      theme: data.theme === 'dark' ? 'dark' : 'light',
      fontScale: Number.isFinite(data.fontScale) ? Math.max(0.85, Math.min(1.4, Math.round(data.fontScale * 100) / 100)) : 1,
      last: last && Number.isInteger(last.surah) && last.surah >= 1 && last.surah <= 114 && Number.isInteger(last.verse) && last.verse >= 1 && last.verse <= 286 ? last : null,
    };
  } catch { return { ...DEFAULT_STATE }; }
}
export function saveState(storage, state) {
  try { storage.setItem(STORAGE_KEY, JSON.stringify(state)); return true; }
  catch { return false; }
}
export function parseRoute(hash, surahs) {
  const match = /^#(\d+)(?::(\d+))?$/.exec(hash);
  if (!match) return null;
  const surah = Number(match[1]);
  const verse = Number(match[2] || 1);
  const chapter = surahs.find(s => s.number === surah);
  return chapter && verse >= 1 && verse <= chapter.numberOfAyahs ? { surah, verse } : null;
}
export function audioUrl(surah) {
  return `https://download.quranicaudio.com/qdc/mishari_al_afasy/murattal/${surah}.mp3`;
}
export function verseAtTime(starts, seconds) {
  let low = 0, high = starts.length - 1;
  while (low < high) {
    const mid = Math.ceil((low + high) / 2);
    if (starts[mid] <= seconds) low = mid;
    else high = mid - 1;
  }
  return low + 1;
}
export function formatAudioTime(value) {
  const seconds = Math.max(0, Math.floor(Number.isFinite(value) ? value : 0));
  const minutes = Math.floor(seconds / 60);
  const tail = String(seconds % 60).padStart(2, '0');
  return minutes >= 60 ? `${Math.floor(minutes / 60)}:${String(minutes % 60).padStart(2, '0')}:${tail}` : `${minutes}:${tail}`;
}
